import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'

export const myClassifiedsSearchConfig: SearchConfig = Object.freeze({
  settings: {
    viewType: {
      defaultViewTypeDesktop: ViewType.LIST,
      defaultViewTypeMobile: ViewType.LIST
    },
    searchName: 'list',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/my/query/',
      usesNuxtLinks: false
    },
    displayAds: true
  },
  rootParams: {
    sort: ['dm'],
    myclassifieds: ['1'],
    category: [20001]
  }
})
